/**
 * Tiny event bus so a page can open the floating assistant and say WHERE the
 * lawyer came from (the criminal home's "Something else…" card). A window
 * CustomEvent keeps the sender free of any ChatPanel import or context.
 *
 * The entry only shapes that one fresh chat's welcome (its starters and hint);
 * opening the assistant from its own button always shows the usual help desk.
 */
const EVENT = 'iadvocate:open-assistant';

export type AssistantEntry = 'something_else';

export function openAssistant(entry: AssistantEntry): void {
  window.dispatchEvent(new CustomEvent<AssistantEntry>(EVENT, { detail: entry }));
}

/** Subscribe; returns the unsubscribe function. */
export function onOpenAssistant(cb: (entry: AssistantEntry) => void): () => void {
  const handler = (e: Event) => {
    const entry = (e as CustomEvent<unknown>).detail;
    if (entry === 'something_else') cb(entry);
  };
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
